import Runtime from '../../../core/helpers/runtime.js';

export default function setBodyClass() {
  const body = document.querySelector('body');

  if (Runtime.device.isAndroid) {
    body.classList.add('mobile-os-android');
  }

  if (Runtime.device.isIPad) {
    body.classList.add('mobile-ipad');
  }

  if (Runtime.device.isIOS) {
    body.classList.add('mobile-iphone');
  }

  if (Runtime.device.isMobileOS) {
    body.classList.add('mobile-os');
  }
}
